import styles from './AnimatedPieChart.module.scss';
import PropTypes from 'prop-types';
import { calculateAngles, rmScoreDecompositionAdaptor } from './helpers';
import PieChart from './pie-chart/PieChart';
import { motion } from 'framer-motion';

const AnimatedPieChart = ({ chartData, setVisibility }) => {
    const getSlices = (data) => {
        if (!data) return null;

        return calculateAngles(
            rmScoreDecompositionAdaptor(data).filter((s) => s.score > 0)
        );
    };

    return (
        <motion.div
            className={styles.wrapper}
            initial={{
                opacity: 0
            }}
            animate={{
                opacity: 1,
                transition: { duration: 0.3, delay: 0.3 }
            }}
            exit={{
                opacity: 0,
                transition: { duration: 0.2 }
            }}
        >
            <PieChart
                chartData={chartData}
                sliceData={getSlices(chartData)}
                setVisibility={setVisibility}
            />
        </motion.div>
    );
};

AnimatedPieChart.propTypes = {
    chartData: PropTypes.shape({}),
    setVisibility: PropTypes.func
};

export default AnimatedPieChart;
